// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: true,
    api_url: '',
    envName: 'dev',
    expTimeNotify: 55 * 60 * 1000, // Se notificará a los x min,
    expTime: 60 * 60 * 1000, // La sesión expirará a los x min
    firebase: {
        apiKey: "AIzaSyCOAAna_FkkO4b0PjeFtFuomAkzwj9HNms",
        authDomain: "theme-19cf5.firebaseapp.com",
        databaseURL: "https://theme-19cf5.firebaseio.com",
        projectId: "theme-19cf5",
        storageBucket: "theme-19cf5.appspot.com",
        messagingSenderId: "717539755028"
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts